import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SITE = "https://www.biohackyourself.com/";

/**
 * Featured "Media Partner" callout — Biohack Yourself. Dedicated, single-row
 * editorial block so it doesn't get lost in the technology Partners section.
 */
export default function MediaPartner() {
  return (
    <section
      id="media-partner"
      data-testid="media-partner-section"
      className="py-20 md:py-28 bg-background"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <motion.a
          href={SITE}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="media-partner-link"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="group block rounded-3xl border-2 border-border bg-card overflow-hidden
                     hover:border-primary/55 hover:-translate-y-0.5
                     hover:shadow-[0_28px_70px_-22px_hsl(218_70%_28%/0.32)]
                     transition-all"
        >
          <div className="p-7 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-7">
              <div className="iw-overline mb-4">Our Media Partner
              </div>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-[-0.02em] leading-[1.05]">
                The world&rsquo;s premier source for{" "}
                <em className="not-italic text-primary">wellness, biohacking, and longevity</em>{" "}
                news.
              </h2>
              <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed max-w-2xl">
                <strong className="text-foreground">Biohack Yourself</strong> is the global voice
                of biohacking and longevity. From award-winning documentaries and frontline event
                coverage to a retail print magazine and a viral digital reach of{" "}
                <em className="not-italic text-primary font-semibold">60M+ quarterly</em>, they
                bring the future of health directly to you.
              </p>

              <span
                className="mt-7 inline-flex items-center gap-2 px-5 py-2.5 rounded-full
                           bg-primary text-primary-foreground text-sm md:text-base font-semibold
                           group-hover:gap-3 transition-all"
              >
                Visit Biohack Yourself
                <ArrowUpRight size={16} aria-hidden />
              </span>
            </div>

            <div className="lg:col-span-5 flex lg:justify-end">
              <div className="w-full max-w-[340px] aspect-[5/3] rounded-2xl bg-foreground border border-foreground/10 shadow-md grid place-items-center p-6">
                <img
                  src="https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/x0zs6qq2_BIOHACK%20R%20LOGO-02.avif"
                  alt="Biohack Yourself — global voice of biohacking and longevity (registered trademark)"
                  className="w-full h-auto object-contain max-h-[140px]"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </motion.a>
      </div>
    </section>
  );
}
